import { PlanElementType, useSelectionStore } from '@editorStores'

/**
 * Id of the selected plan element when it is of `type`, otherwise `null`. Plan element selection is
 * shared (the selection store's `planSelection` slot), so consumers narrow it to the kind they
 * render.
 */
const useSelectedPlanElementId = (type: PlanElementType): string | null =>
  useSelectionStore(state =>
    state.planSelection?.planElementType === type ? state.planSelection.guid : null,
  )

export default useSelectedPlanElementId
